module.exports = __webpack_public_path__ + "static_pc/img/team1.191a2c6d.png";